<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Activités</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'activityCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter une activité
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Nom
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(activity, activityIndex) in activities"
              :key="'e' + activityIndex"
            >
              <td class="font-weight-bold">
                {{ resolveAttrValue(activity, 'name') }}
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'activityDetails', params: { activityId: activity.id }}"
                      v-on="on"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click="openDeleteActivityDialog(activity)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!activities.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <DeleteActivityDialog
      :key="Date.now()"
      :activity="activityToDelete"
      :delete-activity-dialog-state="deleteActivityDialogState"
      @closeDeleteActivityDialog="closeDeleteActivityDialog($event)"
    ></DeleteActivityDialog>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import DeleteActivityDialog from '@/components/Dialog/SeoDialog/Activity/DeleteActivityDialog'
import config from '../../../config'
import Loader from '@/components/Common/Loader'

export default {
  components: {
    DeleteActivityDialog,
    Loader
  },
  data: () => ({
    activities: [],
    activityToDelete: null,
    deleteActivityDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan
    }
  }),
  created () {
    this.getActivities()
  },
  methods: {
    getActivities () {
      this.loading = true

      Vue.prototype.$http
        .get(config.apiUrl + '/api/seo/activities', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            const data = response.data

            if (data) {
              this.activities = data
            }
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    openDeleteActivityDialog (activity) {
      this.deleteActivityDialogState = true
      this.activityToDelete = activity
    },
    closeDeleteActivityDialog (deleteState) {
      if (deleteState === true) {
        this.activities = this.activities.filter(element => element.id !== this.activityToDelete.id)
      }

      this.deleteActivityDialogState = false
    },
    resolveAttrValue (data, attr) {
      const translations = data.translations

      if (translations.fr) {
        return translations.fr[attr]
      }

      return '-'
    }
  }
}
</script> 